<template>
  <div class="customer_label">
    <div class="data">
      <div class="data_top">
        <div class="right">
          <!-- <el-button>同步企微标签</el-button> -->
          <el-button @click="add_label_open">+ 添加标签</el-button>
        </div>
      </div>
      <div class="table">
        <el-table
            :data="data.list"
            :header-cell-style="{background:'rgb(249,249,249)'}"
            ref="multipleTable"
            :row-style="{height: '50px'}"
            style="width: 100%;margin-top:10px">
          <el-table-column
              prop="name"
              label="标签组"
              width="300">
          </el-table-column>
          <el-table-column
              prop="tag"
              label="标签"
              align="center">
            <template v-slot="scope">
              <el-tag
                  :key="tag.id"
                  v-for="tag in scope.row.tag"
                  :disable-transitions="false">
                {{tag.name}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="100">
            <template v-slot="scope">
              <span class="tab_btn" @click="edit_label_open(scope.row)">编辑</span>
              <span class="tab_btn" @click="open_del_dialog(scope.row.group_id)" style="color: rgb(249, 104, 104);">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="operation">
        <div class="btn_right">
          <el-pagination
              background
              layout="total,sizes, prev, pager, next"
              prev-text="上一页"
              next-text="下一页"
              :page-sizes="[20, 50, 100, 200, 500]"
              :page-size="data.pagesize"
              :pager-count='5'
              @size-change="type_modify_page"
              @current-change="type_switch_page"
              :total="data.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <Dialog :show.sync="add_label_show" :name_width="add_label_dialog" class="select_members_dialog">
      <span slot="body">
        <div class="label_div">
          <p class="title">标签组：</p>
          <el-input v-model="form.name" placeholder="请输入标签组名称"></el-input>
        </div>
        <div class="label_div">
          <p class="title">标签：</p>
          <div class="add_label" v-for="(value, index) in form.tag">
            <el-input v-model="value.name" placeholder="请输入标签名称" class="label_input"></el-input>
            <i v-show="form.tag.length > 1" class="el-icon-close" @click="destruction_input(index)"></i>
          </div>
          <div class="add_input" @click="create_input">
            <span>+ 添加</span>
          </div>
        </div>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="add_label_save">确 认</el-button>
        <el-button @click="add_label_close">取 消</el-button>
      </div>
    </Dialog>

    <Dialog :show.sync="edit_label_show" :name_width="edit_label_dialog" class="select_members_dialog">
      <span slot="body">
        <div class="label_div">
          <p class="title">标签组：</p>
          <el-input v-model="form.name" placeholder="请输入标签组名称"></el-input>
        </div>
        <div class="label_div">
          <p class="title">标签：</p>
          <div class="add_label" v-for="(value, index) in form.tag">
            <el-input v-model="value.name" placeholder="请输入标签名称" class="label_input"></el-input>
            <i v-show="form.tag.length > 1" class="el-icon-close" @click="destruction_input(index)"></i>
          </div>
          <div class="add_input" @click="create_input">
            <span>+ 添加</span>
          </div>
        </div>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="edit_label_save">确 认</el-button>
        <el-button @click="edit_label_close">取 消</el-button>
      </div>
    </Dialog>

    <!--    删除弹窗-->
    <Dialog :show.sync="del_show" :name_width="del_dialog" class="dialog">
      <span slot="body">
        <p>确定删除这个标签组吗？</p>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="save_del_dialog">确 定</el-button>
        <el-button @click="close_del_dialog">取 消</el-button>
      </div>
    </Dialog>

  </div>
</template>

<script>
import Dialog from "components/content/dialog/Dialog";

import {getCustomerTagList, addCustomerTag, delCustomerTag, editCustomerTag} from 'network/hk_customer'
import {
		retujudpower,
		retupower,
		alertMess,
	} from '@src/network/kh_public'
export default {
  name: "CustomerLabel",
  components: {
    Dialog
  },
  data() {
    return {
		
		is_powerAdd: false,
		is_powerEdit: false,
		is_powerDel: false,
		is_powerImp: false,
		is_powerExp: false,
		is_powerRec: false,
		
      add_label_show: false,
      add_label_dialog: {
        name: '添加标签',
        width: '620px'
      },
      edit_label_show: false,
      edit_label_dialog: {
        name: '编辑标签',
        width: '620px'
      },
      // 删除弹窗
      del_show: false,
      del_dialog: {
        name: '删除标签组',
        width: '300px'
      },
      del_id: null,

      data: {
        pagesize: 20,
        page: 1,
        total: 0,
        list: [],
      },


      value1: '',
      form: {
        name: '',
        tag: [
          {
            name: ''
          }
        ]
      },
      // 删除的标签id
      delLabelId: [],
      // 原有的标签列表
      originalLabelList: [],
      // 新增的标签列表
      addLabelList: []

    }
  },
  created() {
	  this.judgePower()
    this.getCustomerTagList(this.data.pagesize, this.data.page)
  },
  methods: {
	  judgePower() {
	  	this.is_powerAdd = retupower('247')
	  	this.is_powerEdit = retupower('248')
	  	this.is_powerDel = retupower('249')
	  	this.is_powerImp = retupower('250')
	  	this.is_powerExp = retupower('251')
	  	this.is_powerRec = retupower('252')
	  },
    // 添加标签弹窗
    add_label_open() {
		if(retujudpower(this.is_powerAdd)) {
			this.form = {
			  name: '',
			  tag: [
			    {
			      name: ''
			    }
			  ]
			}
			this.add_label_show = true;
		}
      
    },
    add_label_save() {
      let label_list = []
      for (let index in this.form.tag) {
        label_list.push(this.form.tag[index].name)
      }
      if (label_list[0] === '') {
        this.$message({
          message: '至少需要一个标签',
          type: 'error',
          offset: 100
        });
      } else {
        this.addCustomerTag(this.form.name, JSON.stringify(label_list))
      }

    },
    add_label_close() {
      this.add_label_show = false;
    },

    // 编辑标签弹窗
    edit_label_open(row) {
		if(retujudpower(this.is_powerEdit)) {
		  this.form = JSON.parse(JSON.stringify(row));
		  this.delLabelId = []
		  this.edit_label_show = true;
	  }
    },
    edit_label_save() {
      this.originalLabelList = []
      this.addLabelList = []

      if (this.form.tag[0].name === '') {
        this.$message({
          message: '至少需要一个标签',
          type: 'error',
          offset: 100
        });
      } else {
        let flag = true
        for(let i = 0; i < this.form.tag.length; i++){
          for(let j = i+1; j < this.form.tag.length; j++){
            if(this.form.tag[i].name == this.form.tag[j].name){
              flag = false;
              break;
            }
          }
        }
        if (!flag) {
          this.$message({
            message: '标签名称不能重复',
            type: 'error',
            offset: 100
          });
        } else {
          for (let index in this.form.tag) {
            if (this.form.tag[index].id !== undefined) {
              this.originalLabelList.push(this.form.tag[index])
            } else {
              this.addLabelList.push(this.form.tag[index].name)
            }
          }
          this.editCustomerTag(this.form.group_id, this.form.name, JSON.stringify(this.originalLabelList), this.delLabelId.join(), JSON.stringify(this.addLabelList))
        }
      }

    },
    edit_label_close() {
      this.edit_label_show = false;
    },

    destruction_input(index) {
      this.delLabelId.push(this.form.tag[index].id)
      this.form.tag.splice(index, 1);
    },
    // 添加标签
    create_input() {
      this.form.tag.push({name:''})
    },

    // 切换页码
    type_modify_page(val) {
      this.data.pagesize = val
      this.getCustomerTagList(this.data.pagesize, this.data.page)
    },
    type_switch_page(val) {
      this.data.page = val
      this.getCustomerTagList(this.data.pagesize, this.data.page)
    },
    // 删除标签
    delLabel(group_id) {
      this.delCustomerTag(group_id)
    },

    // 删除弹窗
    open_del_dialog(id) {
		if(retujudpower(this.is_powerDel)) {
			this.del_id = id
			this.del_show = true
		}
     
    },
    save_del_dialog() {
      this.delLabel(this.del_id)
    },
    close_del_dialog() {
      this.del_show = false
    },




    // 获取标签列表
    getCustomerTagList(pagesize, page) {
      getCustomerTagList(pagesize, page).then(res => {
        if (res.code === 10000) {
          this.data.list = res.result.data
          this.data.total = res.result.total
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },
    // 添加标签
    addCustomerTag(tag_group_name, tag_name) {
      addCustomerTag(tag_group_name, tag_name).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '添加成功',
            type: 'success',
            offset: 100
          });
          this.getCustomerTagList(this.data.pagesize, this.data.page)
          this.add_label_show = false;
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },
    // 删除标签
    delCustomerTag(group_id) {
      delCustomerTag(group_id).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '删除成功',
            type: 'success',
            offset: 100
          });
          this.getCustomerTagList(this.data.pagesize, this.data.page)
          this.del_show = false
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },
    // 编辑标签
    editCustomerTag(group_id, tag_group_name, edit_tag_info, del_tag_info, add_tag_info) {
      editCustomerTag(group_id, tag_group_name, edit_tag_info, del_tag_info, add_tag_info).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '编辑成功',
            type: 'success',
            offset: 100
          });
          this.getCustomerTagList(this.data.pagesize, this.data.page)
          this.edit_label_show = false;
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.data {
  height: 100%;
  background: #fff;
  padding-bottom: 67px;
}
.data_top {
  width: 100%;
  height: 45px;
}
.right {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}

.btn_right {
  height: 37px;
  margin-right: 10px;
  margin-top: 15px;
}
.table {
  padding: 0 10px;
}

.right>.el-button {
  height: 32px;
  padding: 10px 15px;
  background: var(--themeColors);
  color: #fff;
  border: none;
}
.right>.el-button:hover {
  background: var(--themeColorsHover);
}
/deep/ .el-input__inner:focus {
  border-color: var(--themeColors);
}
.btn_right {
  width: auto;
  margin-right: 15px;
  float: right;
}
/deep/ .el-date-editor .el-range__icon {
  line-height: 25px;
}
.label_box {
  display: inline-block;
  background: #DCEDC8;
  padding: 0 10px;
  border: 1px solid var(--themeColors);
  border-radius: 5px;
  margin-right: 10px;
}
.label_div {
  margin-bottom: 10px;
}
.label_div .title {
  margin-bottom: 10px;
}
.label_div>.el-input {
  margin-bottom: 10px;
}
.label_input {
  width: 540px;
}
.add_label {
  margin-bottom: 15px;
}
.add_label i {
  font-size: 20px;
  margin-left: 20px;
  cursor: pointer;
}
.add_input {
  width: 538px;
  height: 32px;
  border: 1px dashed var(--themeColors);
  cursor: pointer;
  text-align: center;
}
.add_input span{
  line-height: 32px;
  color: var(--themeColors);
}
</style>